<span [innerHtml]="copyrightText()"></span>

iXsystems, Inc. dba

<a
  target="_blank"
  title="iXsystems, Inc. dba TrueNAS."
  tnTestId="copyright"
  tnTestIdType="link"
  [href]="targetHref()"
>
  TrueNAS
</a>
